<template>
  <edit-sidebar class="editTopic">
    <div class="part">
      <h2>Topic</h2>
      <form class="sentry-masked-text" @submit.prevent @keyup.enter.exact="saveAndReturn">
        <app-auto-textarea :modelValue="field" late-focus="true" placeholder="Add topic..." :limit="255" @update:modelValue="handleInput" />
        <app-text-limit-message :limit="255" :warn-limit="200" :value="field" />
      </form>
      <div class="actions btn-pair">
        <button type="button" @click.prevent="cancel">Cancel</button>
        <button type="button" @click.prevent="saveAndReturn">Save</button>
      </div>
    </div>
  </edit-sidebar>
</template>

<script setup>
import { ref, watch, nextTick, getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import AppAutoTextarea from '@/components/AppAutoTextarea.vue';
import AppTextLimitMessage from '@/components/AppTextLimitMessage';
import EditSidebar from '@/components/EditSidebar.vue';
import { usePhaseStore } from '@/store/pinia/phase';
import { useSidebarStore } from '@/store/pinia/sidebar';

const props = defineProps({
  extra: {
    type: Boolean,
    default: false,
  },
});
const { $meetingmanager } = getCurrentInstance().appContext.config.globalProperties;
const phaseStore = usePhaseStore();
const sidebarStore = useSidebarStore();
const field = ref('');
const { topic: fieldContent, topicId } = storeToRefs(phaseStore);
watch(
  fieldContent,
  (nv) => {
    field.value = nv;
  },
  { immediate: true },
);
function handleInput(e) {
  field.value = e;
}
function saveAndReturn() {
  const id = topicId.value || null;
  $meetingmanager.updateTopic({ id, topic: field.value || '' });
  nextTick(() => {
    sidebarStore.finishedWithPane(props.extra);
  });
}
function cancel() {
  sidebarStore.finishedWithPane(props.extra);
}
</script>
